import React, { useEffect, useState, useContext } from "react";
import { CustomConfirmationDialog } from "../ModalCuston"; // Componente de modal existente
import { CoreContext } from "context/CoreContext";
import { getCarouselMessages, saveStatusMessage } from "services/message";
import { toast } from "react-toastify";

export default function CarouselModal() {
  const { user, currentCompany } = useContext(CoreContext);
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [notifications, setNotifications] = useState([]);

  // função que busca a lista de mensagens
  const getMessages = async () => {
    try {
      if (user?.id) {
        const result = await getCarouselMessages(user.id);

        if (result && Array.isArray(result)) {
          toast.success("Dados salvos com sucesso!");
          return result;
        } else {
          toast.error("Erro ao buscar mensagens do carrossel.");
          return [];
        }
      }
    } catch (err) {
      console.error("Erro ao buscar mensagens:", err.message);
      toast.error("Erro ao carregar as mensagens!");
      return [];
    }
  };

  useEffect(() => {
    const processNotifications = async () => {
      try {
        const messages = await getMessages(); // Aguarda a lista de mensagens

        if (Array.isArray(messages)) {
          const processedNotifications = messages.map((notification) => {
            return notification; // Retorna notificações diretamente
          });

          setNotifications(processedNotifications); // Atualiza o estado
        } else {
          console.error("Erro: getMessages não retornou um array.");
          toast.error("Erro ao carregar as notificações.");
          setNotifications([]);
        }
      } catch (err) {
        console.error("Erro ao processar notificações:", err);
        toast.error("Erro ao carregar as notificações!");
        setNotifications([]);
      }
    };

    processNotifications();
  }, []);

  useEffect(() => {
    if (user?.isManager && notifications.length > 0) {
      setOpen(true);
    }
  }, [user, notifications]);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < notifications.length - 1 ? prevIndex + 1 : 0
    );
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : notifications.length - 1
    );
  };

  const handleDoNotShowAgain = async () => {
    // Captura o ID da mensagem que será excluída
    const messageId = notifications[currentIndex]?.id;

    // Filtra as notificações para excluir a atual
    const updatedNotifications = notifications.filter(
      (_, i) => i !== currentIndex
    );

    const payload = {
      type: "message",
      payload: {
        messageId: messageId,
        userId: user.id,
        companyId: currentCompany?.id,
      },
    };

    // Salvar o ID no banco de dados
    await saveStatusMessage(payload); // Função para salvar no banco

    setNotifications(updatedNotifications);

    if (updatedNotifications.length === 0) {
      setOpen(false);
    } else {
      setCurrentIndex(Math.min(currentIndex, updatedNotifications.length - 1));
    }
  };

  const handleCancel = () => setOpen(false);

  const handleLearnMore = () => {
    const link = notifications[currentIndex]?.link;

    if (link !== null || link !== undefined || link.trim() !== "") {
      window.open(link, "_blank");
    }
  };

  return (
    notifications.length > 0 && (
      <CustomConfirmationDialog
        open={open}
        title="Notificação Importante"
        message={notifications[currentIndex]?.name}
        carouselItems={notifications}
        currentIndex={currentIndex}
        onCancel={handleCancel} // Função para fechar o modal
        onNext={handleNext}
        onPrevious={handlePrevious}
        onLearnMore={handleLearnMore} // Passa a ação para "Saiba Mais"
        onDoNotShowAgain={handleDoNotShowAgain} // Passa a ação para "Não Exibir Novamente"
      />
    )
  );
}
